import { render, staticRenderFns } from "./FixedAssetBrowser.yaml?vue&type=template&id=37f8d9c3&component"
import script from "./FixedAssetBrowser.yaml?vue&type=script&lang=ts&component"
export * from "./FixedAssetBrowser.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports